const maxLength = max => (value, previousValue) =>
  value && value.length > max ? previousValue : value;

export { maxLength };



// WEBPACK FOOTER //
// ./src/lib/normalization.js